(function () {
  'use strict';

  if (window.UdbVariantPrice) return;

  const variantAdminPriceCache = Object.create(null);

  function toNumber(value, fallback = 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function registerVariantAdminPrice(variantId, priceCents) {
    const id = String(variantId || '').trim();
    const cents = toNumber(priceCents, 0);
    if (!id || cents <= 0) return;
    variantAdminPriceCache[id] = cents;
  }

  function registerVariantsFromProduct(product) {
    if (!product || !Array.isArray(product.variants)) return;

    product.variants.forEach((variant) => {
      registerVariantAdminPrice(variant.id, variant.price);
    });
  }

  function getCachedVariantAdminPriceCents(variantId) {
    const id = String(variantId || '').trim();
    if (!id) return 0;
    return toNumber(variantAdminPriceCache[id], 0);
  }

  /**
   * Sale shelf price for one cart line (cents) — tier unlock / UDB discount basis.
   * Uses original_line_price first (actual line at variant price), then original_price,
   * then item.price. Never compare_at_price.
   */
  function getLineAdminVariantUnitCents(item) {
    const quantity = Math.max(1, toNumber(item?.quantity, 0));
    const originalLineCents = toNumber(item?.original_line_price, 0);
    if (originalLineCents > 0) {
      return Math.round(originalLineCents / quantity);
    }

    const originalCents = toNumber(item?.original_price, 0);
    if (originalCents > 0) return originalCents;

    const priceCents = toNumber(item?.price, 0);
    if (priceCents > 0) return priceCents;

    return getCachedVariantAdminPriceCents(item?.variant_id);
  }

  function getLineAdminVariantLineCents(item) {
    const originalLineCents = toNumber(item?.original_line_price, 0);
    if (originalLineCents > 0) return originalLineCents;

    const quantity = Math.max(0, toNumber(item?.quantity, 0));
    if (!quantity) return 0;

    return getLineAdminVariantUnitCents(item) * quantity;
  }

  function getTierBasisSubtotalCents(cart) {
    const items = cart?.items;
    if (!Array.isArray(items) || !items.length) {
      return toNumber(cart?.items_subtotal_price, 0);
    }

    return items.reduce((sum, item) => sum + getLineAdminVariantLineCents(item), 0);
  }

  function seedCacheFromCart(cart) {
    const items = cart?.items;
    if (!Array.isArray(items)) return;

    items.forEach((item) => {
      const quantity = Math.max(1, toNumber(item?.quantity, 0));
      const originalLineCents = toNumber(item?.original_line_price, 0);
      if (originalLineCents > 0) {
        registerVariantAdminPrice(item.variant_id, Math.round(originalLineCents / quantity));
        return;
      }

      if (toNumber(item?.original_price, 0) > 0) {
        registerVariantAdminPrice(item.variant_id, item.original_price);
        return;
      }

      if (toNumber(item?.price, 0) > 0) {
        registerVariantAdminPrice(item.variant_id, item.price);
      }
    });
  }

  function bindVariantChangeCatalog() {
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      if (variant?.id && toNumber(variant.price, 0) > 0) {
        registerVariantAdminPrice(variant.id, variant.price);
      }
    });
  }

  function bootstrapProductJsonCatalog() {
    document.querySelectorAll('script[type="application/json"][data-product-json]').forEach((node) => {
      try {
        registerVariantsFromProduct(JSON.parse(node.textContent || '{}'));
      } catch (error) {
        /* ignore invalid product json */
      }
    });
  }

  bindVariantChangeCatalog();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapProductJsonCatalog);
  } else {
    bootstrapProductJsonCatalog();
  }

  window.UdbVariantPrice = {
    registerVariantAdminPrice,
    registerVariantsFromProduct,
    getLineAdminVariantUnitCents,
    getLineAdminVariantLineCents,
    getTierBasisSubtotalCents,
    seedCacheFromCart,
  };
})();
